(function () {
  const currentPath = window.location.pathname;
  const search = window.location.search;
  const hash = window.location.hash;

  let normalizedPath = currentPath.replace(/\/{2,}/g, '/');

  if (normalizedPath.length > 1 && normalizedPath.endsWith('/')) {
    normalizedPath = normalizedPath.slice(0, -1);
  }

  if (normalizedPath !== currentPath) {
    window.location.replace(normalizedPath + search + hash);
  }
})();
